module.exports = __webpack_public_path__ + "static/media/211IT005.8ba6a849.jpeg";